<script setup lang="ts">
import {
  BrokerTop,
  BrokerAbout,
  BrokerAudience,
  BrokerFeatures,
  BrokerFooter,
  BrokerForm,
  BrokerHero,
  BrokerReasons,
} from '~/entities/broker-pass';

import { useYandexMetrikaHead } from '~/shared/utils/useYandexMetrikaHead';
import {
  OG_IMAGE_HEIGHT,
  OG_IMAGE_WIDTH,
  OG_SITE_NAME,
  OG_TYPE,
  getAbsoluteUrl,
} from '~/shared/lib/seo';
import OgBrokerImage from '~/shared/images/og-broker-image.jpg';
import { useOrigin } from '~/shared/lib/useOrigin';

const origin = useOrigin();
const title = 'Брокер Пасс';
const description = 'Профессиональный инструмент для брокеров и консалтинга';
const keywords =
  'brokerpass, cre, коммерческая недвижимость, брокеры недвижимости, база объектов, сделки с недвижимостью, аренда офисов, инвестиции в недвижимость, рынок недвижимости';

const canonicalUrl = origin + '/';
useHead({
  title,
  link: [{ rel: 'canonical', href: canonicalUrl }],
  meta: [
    {
      name: 'description',
      content: description,
    },
    { name: 'keywords', content: keywords },
    { property: 'og:type', content: OG_TYPE },
    { property: 'og:title', content: title },
    { property: 'og:keywords', content: keywords },
    { property: 'og:description', content: description },
    { property: 'og:site_name', content: OG_SITE_NAME },
    {
      property: 'og:image',
      content: getAbsoluteUrl(origin, OgBrokerImage),
    },
    /* Same size as the default og-image */
    { property: 'og:image:width', content: String(OG_IMAGE_WIDTH) },
    { property: 'og:image:height', content: String(OG_IMAGE_HEIGHT) },
  ],
});

useYandexMetrikaHead();
</script>

<template>
  <div class="page-layout">
    <div class="page-container">
      <main class="sections-wrapper">
        <BrokerTop />
        <BrokerHero />
        <BrokerFeatures />
        <BrokerAudience />
        <BrokerReasons />
        <BrokerForm />
        <BrokerAbout />
        <BrokerFooter />
      </main>
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-layout {
  background: #f3f3f3;

  * {
    box-sizing: border-box;
  }
}

.page-container {
  background: var(--anti-flash-white, #f3f3f3);
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
}

.sections-wrapper {
}
</style>
